import React from "react";
import type { IconType } from "react-icons";

/** Wrapper to avoid react-icons JSX component type mismatch with React 19 */
export default function Icon({
  icon: I,
  className,
  style,
}: {
  icon: IconType;
  className?: string;
  style?: React.CSSProperties;
}) {
  return <>{I({ className, style, "aria-hidden": true } as any)}</>;
}
